import { render } from "./trailer-timeline.vue?vue&type=template&id=0a8bc8d4&scoped=true"
import script from "./trailer-timeline.vue?vue&type=script&lang=ts"
export * from "./trailer-timeline.vue?vue&type=script&lang=ts"

import "./trailer-timeline.vue?vue&type=style&index=0&id=0a8bc8d4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a8bc8d4"

export default script